<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
window.jQuery = window.$ = require('jquery');
export default {
  name: 'app',
  data () {
    return {
      autostart: true,
    }
  }
}
</script>

